import { defineStore } from 'pinia';

interface State {
  isTranslationEnabled: boolean;
}

export const useConductStore = defineStore('conduct', {
  state: () : State => ({ isTranslationEnabled: false }),
  actions: {
    setIsTranslationEnabled(value: boolean) {
      this.isTranslationEnabled = value;
    },
  },
});
